import React, { useState, useEffect } from 'react';

const LoadingScreen = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simuler un chargement initial
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-gradient-to-br from-purple-50 via-violet-50 to-fuchsia-50 flex items-center justify-center">
      <div className="text-center">
        {/* Logo animé */}
        <div className="mb-8 flex items-center justify-center">
          <img 
            src="/logo-trakzstudio.png" 
            alt="TRAKZSTUDIO Logo" 
            className="h-24 w-auto animate-pulse"
          />
        </div>
        
        {/* Texte */}
        <h2 className="text-2xl font-bold bg-gradient-to-r from-purple-600 via-violet-500 to-fuchsia-500 bg-clip-text text-transparent mb-4">
          TRAKZSTUDIO
        </h2>
        
        {/* Barre de progression */}
        <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-purple-600 via-violet-500 to-fuchsia-500 animate-loading-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
